import React from 'react';
import { Helmet } from 'react-helmet-async';

// @mui
import { styled } from '@mui/material/styles';
import { Box, Card, Button, Typography } from '@mui/material';

import 'react-toastify/dist/ReactToastify.css';
import SettingsIcon from '@mui/icons-material/Settings';
import AdminSettingForm from 'src/sections/adminSetting/AdminSettingForm';
// import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

// home main section container.
const MainSection = styled('div')(({ theme }) => ({
    padding: "64px 24px 14px 90px",
    // backgroundColor: theme.palette.background.default,
    // backgroundColor: "#F7F8FA",
    [theme.breakpoints.down('sm')]: {
        padding: '56px 14px 14px 14px',
    },
}));

// Show home hading and filtes
const HeadingSection = styled('div')(() => ({
    width: '100%',
    padding: "20px 0px 20px 0px",
    justifyContent: 'space-between'
}));

const ListAndDetailsSection = styled('div')(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    // gap: "14px",
    [theme.breakpoints.down('sm')]: {
        flexDirection: "column",
    },
}));

const AdminSetting = () => {

    return (
        <>
            <MainSection>
                <HeadingSection>

                </HeadingSection>
                <Card>
                    <ListAndDetailsSection >
                        <AdminSettingForm />
                    </ListAndDetailsSection>
                </Card>
            </MainSection>

        </>
    )
}

export default AdminSetting;
